<template>

    <div v-if="p != null">
        <!-- <div class="wine-shop-item__year" v-if="p.type == 'vini' && year != null">
            {{year}}
        </div>
        <div class="wine-shop-item__year font-weight-normal no-letter-spacing pr-xl-4" v-else>
            <span v-html="shortenDescription"></span>
        </div> -->
        <div class="">
            <span>€</span>
            <span>
                {{$root.currencyDisplaySimple(price)}}
            </span>
        </div>
    </div>

</template>

<script>
export default {
    props: ['product', 'lang', 'shorten'],
    data() {
        return {
            year: null,
            price: null,
            p: null,
            s: false
        }
    },
    created() {
        this.p = this.product;

        if(typeof this.s != 'undefined') {
            this.s = this.shorten
        }

        this.p.combinations.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });

        this.price = this.p.combinations[0].price;

        for(let i=0; i<this.p.combinations[0].attributes.length; i++) {
            if(this.p.combinations[0].attributes[i].key == 'anno') {
                this.year = this.p.combinations[0].attributes[i].value_label;
            }
        }

    },
    mounted() {
    },
    methods: {
    },
    computed: {
        shortenDescription() {

            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

            if(vw >= 1200 && this.s) {
                return this.p['subtitle_' + this.lang].substring(0, 55) + '...'
            }

            return this.p['subtitle_' + this.lang]

        }
    }
}
</script>
